export default class flexibleSidebar {
    constructor(context) {
        this.context = context;

        this.div = document.querySelector('.c-frontpage__block--full-height');
        this.h3 = document.querySelector('.c-frontpage__title--small');
        this.ul = document.querySelector('.c-widget__list--frontpage');
        this.items = document.querySelectorAll('.c-widget__item--excerpt');

        if (this.div) {
            this.init();
        }
    }

    init() {
        const getClearHeight = list => {
            const getHight = elem => {
                const style = window.getComputedStyle(elem);
                const paddingTop = parseInt(style.paddingTop, 10);
                const paddingBottom = parseInt(style.paddingBottom, 10);

                return elem.clientHeight - paddingTop - paddingBottom;
            };
            const marginTopUl = parseInt(window.getComputedStyle(this.ul).marginTop, 10);

            return getHight(list) - this.h3.offsetHeight - marginTopUl;
        };

        const clearHeight = getClearHeight(this.div);

        [].reduce.call(
            this.items,
            (accumulator, item) => {
                if (accumulator < clearHeight) {
                    item.classList.remove('hidden');
                }

                if (accumulator + item.offsetHeight > clearHeight && !item.classList.contains('hidden')) {
                    item.classList.add('hidden');
                }

                return accumulator + item.offsetHeight;
            },
            0
        );
    }
}
